import _defineProperty from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _slicedToArray from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/usr/src/app/www/node_modules/@babel/runtime/regenerator/index.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "core-js/modules/esnext.global-this.js";

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, basedir, module) {
  return module = {
    path: basedir,
    exports: {},
    require: function require(path, base) {
      return commonjsRequire(path, base === undefined || base === null ? module.path : base);
    }
  }, fn(module, module.exports), module.exports;
}

function commonjsRequire() {
  throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

var phoenix = createCommonjsModule(function (module, exports) {
  !function (e, t) {
    module.exports = t();
  }(commonjsGlobal, function () {
    return function (e) {
      var t = {};

      function n(i) {
        if (t[i]) return t[i].exports;
        var o = t[i] = {
          i: i,
          l: !1,
          exports: {}
        };
        return e[i].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
      }

      return n.m = e, n.c = t, n.d = function (e, t, i) {
        n.o(e, t) || Object.defineProperty(e, t, {
          enumerable: !0,
          get: i
        });
      }, n.r = function (e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(e, "__esModule", {
          value: !0
        });
      }, n.t = function (e, t) {
        if (1 & t && (e = n(e)), 8 & t) return e;
        if (4 & t && "object" == typeof e && e && e.__esModule) return e;
        var i = Object.create(null);
        if (n.r(i), Object.defineProperty(i, "default", {
          enumerable: !0,
          value: e
        }), 2 & t && "string" != typeof e) for (var o in e) {
          n.d(i, o, function (t) {
            return e[t];
          }.bind(null, o));
        }
        return i;
      }, n.n = function (e) {
        var t = e && e.__esModule ? function () {
          return e.default;
        } : function () {
          return e;
        };
        return n.d(t, "a", t), t;
      }, n.o = function (e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }, n.p = "", n(n.s = 0);
    }([function (e, t, n) {
      (function (t) {
        e.exports = t.Phoenix = n(2);
      }).call(this, n(1));
    }, function (e, t) {
      var n;

      n = function () {
        return this;
      }();

      try {
        n = n || new Function("return this")();
      } catch (e) {
        "object" == typeof window && (n = window);
      }

      e.exports = n;
    }, function (e, t, n) {
      function i(e) {
        return function (e) {
          if (Array.isArray(e)) return a(e);
        }(e) || function (e) {
          if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
        }(e) || s(e) || function () {
          throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
      }

      function o(e) {
        return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }

      function r(e, t) {
        return function (e) {
          if (Array.isArray(e)) return e;
        }(e) || function (e, t) {
          if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
          var n = [],
              i = !0,
              o = !1,
              r = void 0;

          try {
            for (var s, a = e[Symbol.iterator](); !(i = (s = a.next()).done) && (n.push(s.value), !t || n.length !== t); i = !0) {
              ;
            }
          } catch (e) {
            o = !0, r = e;
          } finally {
            try {
              i || null == a.return || a.return();
            } finally {
              if (o) throw r;
            }
          }

          return n;
        }(e, t) || s(e, t) || function () {
          throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
      }

      function s(e, t) {
        if (e) {
          if ("string" == typeof e) return a(e, t);
          var n = Object.prototype.toString.call(e).slice(8, -1);
          return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(n) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? a(e, t) : void 0;
        }
      }

      function a(e, t) {
        (null == t || t > e.length) && (t = e.length);

        for (var n = 0, i = new Array(t); n < t; n++) {
          i[n] = e[n];
        }

        return i;
      }

      function c(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function u(e, t) {
        for (var n = 0; n < t.length; n++) {
          var i = t[n];
          i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
        }
      }

      function h(e, t, n) {
        return t && u(e.prototype, t), n && u(e, n), e;
      }

      n.r(t), n.d(t, "Channel", function () {
        return _;
      }), n.d(t, "Serializer", function () {
        return H;
      }), n.d(t, "Socket", function () {
        return U;
      }), n.d(t, "LongPoll", function () {
        return D;
      }), n.d(t, "Ajax", function () {
        return M;
      }), n.d(t, "Presence", function () {
        return N;
      });

      var l = "undefined" != typeof self ? self : null,
          f = "undefined" != typeof window ? window : null,
          d = l || f || void 0,
          p = 0,
          v = 1,
          y = 2,
          m = 3,
          g = "closed",
          k = "errored",
          b = "joined",
          j = "joining",
          C = "leaving",
          E = "phx_close",
          R = "phx_error",
          T = "phx_join",
          S = "phx_reply",
          w = "phx_leave",
          A = [E, R, T, S, w],
          L = "longpoll",
          x = "websocket",
          O = function O(e) {
        if ("function" == typeof e) return e;
        return function () {
          return e;
        };
      },
          P = function () {
        function e(t, n, i, o) {
          c(this, e), this.channel = t, this.event = n, this.payload = i || function () {
            return {};
          }, this.receivedResp = null, this.timeout = o, this.timeoutTimer = null, this.recHooks = [], this.sent = !1;
        }

        return h(e, [{
          key: "resend",
          value: function value(e) {
            this.timeout = e, this.reset(), this.send();
          }
        }, {
          key: "send",
          value: function value() {
            this.hasReceived("timeout") || (this.startTimeout(), this.sent = !0, this.channel.socket.push({
              topic: this.channel.topic,
              event: this.event,
              payload: this.payload(),
              ref: this.ref,
              join_ref: this.channel.joinRef()
            }));
          }
        }, {
          key: "receive",
          value: function value(e, t) {
            return this.hasReceived(e) && t(this.receivedResp.response), this.recHooks.push({
              status: e,
              callback: t
            }), this;
          }
        }, {
          key: "reset",
          value: function value() {
            this.cancelRefEvent(), this.ref = null, this.refEvent = null, this.receivedResp = null, this.sent = !1;
          }
        }, {
          key: "matchReceive",
          value: function value(e) {
            var t = e.status,
                n = e.response;
            e.ref;
            this.recHooks.filter(function (e) {
              return e.status === t;
            }).forEach(function (e) {
              return e.callback(n);
            });
          }
        }, {
          key: "cancelRefEvent",
          value: function value() {
            this.refEvent && this.channel.off(this.refEvent);
          }
        }, {
          key: "cancelTimeout",
          value: function value() {
            clearTimeout(this.timeoutTimer), this.timeoutTimer = null;
          }
        }, {
          key: "startTimeout",
          value: function value() {
            var e = this;
            this.timeoutTimer && this.cancelTimeout(), this.ref = this.channel.socket.makeRef(), this.refEvent = this.channel.replyEventName(this.ref), this.channel.on(this.refEvent, function (t) {
              e.cancelRefEvent(), e.cancelTimeout(), e.receivedResp = t, e.matchReceive(t);
            }), this.timeoutTimer = setTimeout(function () {
              e.trigger("timeout", {});
            }, this.timeout);
          }
        }, {
          key: "hasReceived",
          value: function value(e) {
            return this.receivedResp && this.receivedResp.status === e;
          }
        }, {
          key: "trigger",
          value: function value(e, t) {
            this.channel.trigger(this.refEvent, {
              status: e,
              response: t
            });
          }
        }]), e;
      }(),
          _ = function () {
        function e(t, n, i) {
          var o = this;
          c(this, e), this.state = g, this.topic = t, this.params = O(n || {}), this.socket = i, this.bindings = [], this.bindingRef = 0, this.timeout = this.socket.timeout, this.joinedOnce = !1, this.joinPush = new P(this, T, this.params, this.timeout), this.pushBuffer = [], this.stateChangeRefs = [], this.rejoinTimer = new J(function () {
            o.socket.isConnected() && o.rejoin();
          }, this.socket.rejoinAfterMs), this.stateChangeRefs.push(this.socket.onError(function () {
            return o.rejoinTimer.reset();
          })), this.stateChangeRefs.push(this.socket.onOpen(function () {
            o.rejoinTimer.reset(), o.isErrored() && o.rejoin();
          })), this.joinPush.receive("ok", function () {
            o.state = b, o.rejoinTimer.reset(), o.pushBuffer.forEach(function (e) {
              return e.send();
            }), o.pushBuffer = [];
          }), this.joinPush.receive("error", function () {
            o.state = k, o.socket.isConnected() && o.rejoinTimer.scheduleTimeout();
          }), this.onClose(function () {
            o.rejoinTimer.reset(), o.socket.hasLogger() && o.socket.log("channel", "close ".concat(o.topic, " ").concat(o.joinRef())), o.state = g, o.socket.remove(o);
          }), this.onError(function (e) {
            o.socket.hasLogger() && o.socket.log("channel", "error ".concat(o.topic), e), o.isJoining() && o.joinPush.reset(), o.state = k, o.socket.isConnected() && o.rejoinTimer.scheduleTimeout();
          }), this.joinPush.receive("timeout", function () {
            o.socket.hasLogger() && o.socket.log("channel", "timeout ".concat(o.topic, " (").concat(o.joinRef(), ")"), o.joinPush.timeout), new P(o, w, O({}), o.timeout).send(), o.state = k, o.joinPush.reset(), o.socket.isConnected() && o.rejoinTimer.scheduleTimeout();
          }), this.on(S, function (e, t) {
            o.trigger(o.replyEventName(t), e);
          });
        }

        return h(e, [{
          key: "join",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.timeout;
            if (this.joinedOnce) throw new Error("tried to join multiple times. 'join' can only be called a single time per channel instance");
            return this.timeout = e, this.joinedOnce = !0, this.rejoin(), this.joinPush;
          }
        }, {
          key: "onClose",
          value: function value(e) {
            this.on(E, e);
          }
        }, {
          key: "onError",
          value: function value(e) {
            return this.on(R, function (t) {
              return e(t);
            });
          }
        }, {
          key: "on",
          value: function value(e, t) {
            var n = this.bindingRef++;
            return this.bindings.push({
              event: e,
              ref: n,
              callback: t
            }), n;
          }
        }, {
          key: "off",
          value: function value(e, t) {
            this.bindings = this.bindings.filter(function (n) {
              return !(n.event === e && (void 0 === t || t === n.ref));
            });
          }
        }, {
          key: "canPush",
          value: function value() {
            return this.socket.isConnected() && this.isJoined();
          }
        }, {
          key: "push",
          value: function value(e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this.timeout;
            if (t = t || {}, !this.joinedOnce) throw new Error("tried to push '".concat(e, "' to '").concat(this.topic, "' before joining. Use channel.join() before pushing events"));
            var i = new P(this, e, function () {
              return t;
            }, n);
            return this.canPush() ? i.send() : (i.startTimeout(), this.pushBuffer.push(i)), i;
          }
        }, {
          key: "leave",
          value: function value() {
            var e = this,
                t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.timeout;
            this.rejoinTimer.reset(), this.joinPush.cancelTimeout(), this.state = C;

            var n = function n() {
              e.socket.hasLogger() && e.socket.log("channel", "leave ".concat(e.topic)), e.trigger(E, "leave");
            },
                i = new P(this, w, O({}), t);

            return i.receive("ok", function () {
              return n();
            }).receive("timeout", function () {
              return n();
            }), i.send(), this.canPush() || i.trigger("ok", {}), i;
          }
        }, {
          key: "onMessage",
          value: function value(e, t, n) {
            return t;
          }
        }, {
          key: "isLifecycleEvent",
          value: function value(e) {
            return A.indexOf(e) >= 0;
          }
        }, {
          key: "isMember",
          value: function value(e, t, n, i) {
            return this.topic === e && (!i || i === this.joinRef() || !this.isLifecycleEvent(t) || (this.socket.hasLogger() && this.socket.log("channel", "dropping outdated message", {
              topic: e,
              event: t,
              payload: n,
              joinRef: i
            }), !1));
          }
        }, {
          key: "joinRef",
          value: function value() {
            return this.joinPush.ref;
          }
        }, {
          key: "rejoin",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.timeout;
            this.isLeaving() || (this.socket.leaveOpenTopic(this.topic), this.state = j, this.joinPush.resend(e));
          }
        }, {
          key: "trigger",
          value: function value(e, t, n, i) {
            var o = this.onMessage(e, t, n, i);
            if (t && !o) throw new Error("channel onMessage callbacks must return the payload, modified or unmodified");

            for (var r = this.bindings.filter(function (t) {
              return t.event === e;
            }), s = 0; s < r.length; s++) {
              r[s].callback(o, n, i || this.joinRef());
            }
          }
        }, {
          key: "replyEventName",
          value: function value(e) {
            return "chan_reply_".concat(e);
          }
        }, {
          key: "isClosed",
          value: function value() {
            return this.state === g;
          }
        }, {
          key: "isErrored",
          value: function value() {
            return this.state === k;
          }
        }, {
          key: "isJoined",
          value: function value() {
            return this.state === b;
          }
        }, {
          key: "isJoining",
          value: function value() {
            return this.state === j;
          }
        }, {
          key: "isLeaving",
          value: function value() {
            return this.state === C;
          }
        }]), e;
      }(),
          H = {
        HEADER_LENGTH: 1,
        META_LENGTH: 4,
        KINDS: {
          push: 0,
          reply: 1,
          broadcast: 2
        },
        encode: function encode(e, t) {
          if (e.payload.constructor === ArrayBuffer) return t(this.binaryEncode(e));
          var n = [e.join_ref, e.ref, e.topic, e.event, e.payload];
          return t(JSON.stringify(n));
        },
        decode: function decode(e, t) {
          if (e.constructor === ArrayBuffer) return t(this.binaryDecode(e));
          var n = r(JSON.parse(e), 5);
          return t({
            join_ref: n[0],
            ref: n[1],
            topic: n[2],
            event: n[3],
            payload: n[4]
          });
        },
        binaryEncode: function binaryEncode(e) {
          var t = e.join_ref,
              n = e.ref,
              i = e.event,
              o = e.topic,
              r = e.payload,
              s = this.META_LENGTH + t.length + n.length + o.length + i.length,
              a = new ArrayBuffer(this.HEADER_LENGTH + s),
              c = new DataView(a),
              u = 0;
          c.setUint8(u++, this.KINDS.push), c.setUint8(u++, t.length), c.setUint8(u++, n.length), c.setUint8(u++, o.length), c.setUint8(u++, i.length), Array.from(t, function (e) {
            return c.setUint8(u++, e.charCodeAt(0));
          }), Array.from(n, function (e) {
            return c.setUint8(u++, e.charCodeAt(0));
          }), Array.from(o, function (e) {
            return c.setUint8(u++, e.charCodeAt(0));
          }), Array.from(i, function (e) {
            return c.setUint8(u++, e.charCodeAt(0));
          });
          var h = new Uint8Array(a.byteLength + r.byteLength);
          return h.set(new Uint8Array(a), 0), h.set(new Uint8Array(r), a.byteLength), h.buffer;
        },
        binaryDecode: function binaryDecode(e) {
          var t = new DataView(e),
              n = t.getUint8(0),
              i = new TextDecoder();

          switch (n) {
            case this.KINDS.push:
              return this.decodePush(e, t, i);

            case this.KINDS.reply:
              return this.decodeReply(e, t, i);

            case this.KINDS.broadcast:
              return this.decodeBroadcast(e, t, i);
          }
        },
        decodePush: function decodePush(e, t, n) {
          var i = t.getUint8(1),
              o = t.getUint8(2),
              r = t.getUint8(3),
              s = this.HEADER_LENGTH + this.META_LENGTH - 1,
              a = n.decode(e.slice(s, s + i));
          s += i;
          var c = n.decode(e.slice(s, s + o));
          s += o;
          var u = n.decode(e.slice(s, s + r));
          return s += r, {
            join_ref: a,
            ref: null,
            topic: c,
            event: u,
            payload: e.slice(s, e.byteLength)
          };
        },
        decodeReply: function decodeReply(e, t, n) {
          var i = t.getUint8(1),
              o = t.getUint8(2),
              r = t.getUint8(3),
              s = t.getUint8(4),
              a = this.HEADER_LENGTH + this.META_LENGTH,
              c = n.decode(e.slice(a, a + i));
          a += i;
          var u = n.decode(e.slice(a, a + o));
          a += o;
          var h = n.decode(e.slice(a, a + r));
          a += r;
          var l = n.decode(e.slice(a, a + s));
          a += s;
          var f = e.slice(a, e.byteLength);
          return {
            join_ref: c,
            ref: u,
            topic: h,
            event: S,
            payload: {
              status: l,
              response: f
            }
          };
        },
        decodeBroadcast: function decodeBroadcast(e, t, n) {
          var i = t.getUint8(1),
              o = t.getUint8(2),
              r = this.HEADER_LENGTH + 2,
              s = n.decode(e.slice(r, r + i));
          r += i;
          var a = n.decode(e.slice(r, r + o));
          return r += o, {
            join_ref: null,
            ref: null,
            topic: s,
            event: a,
            payload: e.slice(r, e.byteLength)
          };
        }
      },
          U = function () {
        function e(t) {
          var n = this,
              i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          c(this, e), this.stateChangeCallbacks = {
            open: [],
            close: [],
            error: [],
            message: []
          }, this.channels = [], this.sendBuffer = [], this.ref = 0, this.timeout = i.timeout || 1e4, this.transport = i.transport || d.WebSocket || D, this.defaultEncoder = H.encode.bind(H), this.defaultDecoder = H.decode.bind(H), this.closeWasClean = !1, this.unloaded = !1, this.binaryType = i.binaryType || "arraybuffer", this.transport !== D ? (this.encode = i.encode || this.defaultEncoder, this.decode = i.decode || this.defaultDecoder) : (this.encode = this.defaultEncoder, this.decode = this.defaultDecoder), f && f.addEventListener && f.addEventListener("beforeunload", function (e) {
            n.conn && (n.unloaded = !0, n.abnormalClose("unloaded"));
          }), this.heartbeatIntervalMs = i.heartbeatIntervalMs || 3e4, this.rejoinAfterMs = function (e) {
            return i.rejoinAfterMs ? i.rejoinAfterMs(e) : [1e3, 2e3, 5e3][e - 1] || 1e4;
          }, this.reconnectAfterMs = function (e) {
            return n.unloaded ? 100 : i.reconnectAfterMs ? i.reconnectAfterMs(e) : [10, 50, 100, 150, 200, 250, 500, 1e3, 2e3][e - 1] || 5e3;
          }, this.logger = i.logger || null, this.longpollerTimeout = i.longpollerTimeout || 2e4, this.params = O(i.params || {}), this.endPoint = "".concat(t, "/").concat(x), this.vsn = i.vsn || "2.0.0", this.heartbeatTimer = null, this.pendingHeartbeatRef = null, this.reconnectTimer = new J(function () {
            n.teardown(function () {
              return n.connect();
            });
          }, this.reconnectAfterMs);
        }

        return h(e, [{
          key: "protocol",
          value: function value() {
            return location.protocol.match(/^https/) ? "wss" : "ws";
          }
        }, {
          key: "endPointURL",
          value: function value() {
            var e = M.appendParams(M.appendParams(this.endPoint, this.params()), {
              vsn: this.vsn
            });
            return "/" !== e.charAt(0) ? e : "/" === e.charAt(1) ? "".concat(this.protocol(), ":").concat(e) : "".concat(this.protocol(), "://").concat(location.host).concat(e);
          }
        }, {
          key: "disconnect",
          value: function value(e, t, n) {
            this.closeWasClean = !0, this.reconnectTimer.reset(), this.teardown(e, t, n);
          }
        }, {
          key: "connect",
          value: function value(e) {
            var t = this;
            e && (console && console.log("passing params to connect is deprecated. Instead pass :params to the Socket constructor"), this.params = O(e)), this.conn || (this.closeWasClean = !1, this.conn = new this.transport(this.endPointURL()), this.conn.binaryType = this.binaryType, this.conn.timeout = this.longpollerTimeout, this.conn.onopen = function () {
              return t.onConnOpen();
            }, this.conn.onerror = function (e) {
              return t.onConnError(e);
            }, this.conn.onmessage = function (e) {
              return t.onConnMessage(e);
            }, this.conn.onclose = function (e) {
              return t.onConnClose(e);
            });
          }
        }, {
          key: "log",
          value: function value(e, t, n) {
            this.logger(e, t, n);
          }
        }, {
          key: "hasLogger",
          value: function value() {
            return null !== this.logger;
          }
        }, {
          key: "onOpen",
          value: function value(e) {
            var t = this.makeRef();
            return this.stateChangeCallbacks.open.push([t, e]), t;
          }
        }, {
          key: "onClose",
          value: function value(e) {
            var t = this.makeRef();
            return this.stateChangeCallbacks.close.push([t, e]), t;
          }
        }, {
          key: "onError",
          value: function value(e) {
            var t = this.makeRef();
            return this.stateChangeCallbacks.error.push([t, e]), t;
          }
        }, {
          key: "onMessage",
          value: function value(e) {
            var t = this.makeRef();
            return this.stateChangeCallbacks.message.push([t, e]), t;
          }
        }, {
          key: "onConnOpen",
          value: function value() {
            this.hasLogger() && this.log("transport", "connected to ".concat(this.endPointURL())), this.unloaded = !1, this.closeWasClean = !1, this.flushSendBuffer(), this.reconnectTimer.reset(), this.resetHeartbeat(), this.stateChangeCallbacks.open.forEach(function (e) {
              return (0, r(e, 2)[1])();
            });
          }
        }, {
          key: "resetHeartbeat",
          value: function value() {
            var e = this;
            this.conn && this.conn.skipHeartbeat || (this.pendingHeartbeatRef = null, clearInterval(this.heartbeatTimer), this.heartbeatTimer = setInterval(function () {
              return e.sendHeartbeat();
            }, this.heartbeatIntervalMs));
          }
        }, {
          key: "teardown",
          value: function value(e, t, n) {
            var i = this;
            if (!this.conn) return e && e();
            this.waitForBufferDone(function () {
              i.conn && (t ? i.conn.close(t, n || "") : i.conn.close()), i.waitForSocketClosed(function () {
                i.conn && (i.conn.onclose = function () {}, i.conn = null), e && e();
              });
            });
          }
        }, {
          key: "waitForBufferDone",
          value: function value(e) {
            var t = this,
                n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
            5 !== n && this.conn && this.conn.bufferedAmount ? setTimeout(function () {
              t.waitForBufferDone(e, n + 1);
            }, 150 * n) : e();
          }
        }, {
          key: "waitForSocketClosed",
          value: function value(e) {
            var t = this,
                n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
            5 !== n && this.conn && this.conn.readyState !== m ? setTimeout(function () {
              t.waitForSocketClosed(e, n + 1);
            }, 150 * n) : e();
          }
        }, {
          key: "onConnClose",
          value: function value(e) {
            this.hasLogger() && this.log("transport", "close", e), this.triggerChanError(), clearInterval(this.heartbeatTimer), this.closeWasClean || this.reconnectTimer.scheduleTimeout(), this.stateChangeCallbacks.close.forEach(function (t) {
              return (0, r(t, 2)[1])(e);
            });
          }
        }, {
          key: "onConnError",
          value: function value(e) {
            this.hasLogger() && this.log("transport", e), this.triggerChanError(), this.stateChangeCallbacks.error.forEach(function (t) {
              return (0, r(t, 2)[1])(e);
            });
          }
        }, {
          key: "triggerChanError",
          value: function value() {
            this.channels.forEach(function (e) {
              e.isErrored() || e.isLeaving() || e.isClosed() || e.trigger(R);
            });
          }
        }, {
          key: "connectionState",
          value: function value() {
            switch (this.conn && this.conn.readyState) {
              case p:
                return "connecting";

              case v:
                return "open";

              case y:
                return "closing";

              default:
                return "closed";
            }
          }
        }, {
          key: "isConnected",
          value: function value() {
            return "open" === this.connectionState();
          }
        }, {
          key: "remove",
          value: function value(e) {
            this.off(e.stateChangeRefs), this.channels = this.channels.filter(function (t) {
              return t.joinRef() !== e.joinRef();
            });
          }
        }, {
          key: "off",
          value: function value(e) {
            for (var t in this.stateChangeCallbacks) {
              this.stateChangeCallbacks[t] = this.stateChangeCallbacks[t].filter(function (t) {
                var n = r(t, 1)[0];
                return -1 === e.indexOf(n);
              });
            }
          }
        }, {
          key: "channel",
          value: function value(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                n = new _(e, t, this);
            return this.channels.push(n), n;
          }
        }, {
          key: "push",
          value: function value(e) {
            var t = this;

            if (this.hasLogger()) {
              var n = e.topic,
                  i = e.event,
                  o = e.payload,
                  r = e.ref,
                  s = e.join_ref;
              this.log("push", "".concat(n, " ").concat(i, " (").concat(s, ", ").concat(r, ")"), o);
            }

            this.isConnected() ? this.encode(e, function (e) {
              return t.conn.send(e);
            }) : this.sendBuffer.push(function () {
              return t.encode(e, function (e) {
                return t.conn.send(e);
              });
            });
          }
        }, {
          key: "makeRef",
          value: function value() {
            var e = this.ref + 1;
            return e === this.ref ? this.ref = 0 : this.ref = e, this.ref.toString();
          }
        }, {
          key: "sendHeartbeat",
          value: function value() {
            if (this.isConnected()) {
              if (this.pendingHeartbeatRef) return this.pendingHeartbeatRef = null, this.hasLogger() && this.log("transport", "heartbeat timeout. Attempting to re-establish connection"), void this.abnormalClose("heartbeat timeout");
              this.pendingHeartbeatRef = this.makeRef(), this.push({
                topic: "phoenix",
                event: "heartbeat",
                payload: {},
                ref: this.pendingHeartbeatRef
              });
            }
          }
        }, {
          key: "abnormalClose",
          value: function value(e) {
            this.closeWasClean = !1, this.conn.readyState === v && this.conn.close(1e3, e);
          }
        }, {
          key: "flushSendBuffer",
          value: function value() {
            this.isConnected() && this.sendBuffer.length > 0 && (this.sendBuffer.forEach(function (e) {
              return e();
            }), this.sendBuffer = []);
          }
        }, {
          key: "onConnMessage",
          value: function value(e) {
            var t = this;
            this.decode(e.data, function (e) {
              var n = e.topic,
                  i = e.event,
                  o = e.payload,
                  s = e.ref,
                  a = e.join_ref;
              s && s === t.pendingHeartbeatRef && (t.pendingHeartbeatRef = null), t.hasLogger() && t.log("receive", "".concat(o.status || "", " ").concat(n, " ").concat(i, " ").concat(s && "(" + s + ")" || ""), o);

              for (var c = 0; c < t.channels.length; c++) {
                var u = t.channels[c];
                u.isMember(n, i, o, a) && u.trigger(i, o, s, a);
              }

              for (var h = 0; h < t.stateChangeCallbacks.message.length; h++) {
                (0, r(t.stateChangeCallbacks.message[h], 2)[1])(e);
              }
            });
          }
        }, {
          key: "leaveOpenTopic",
          value: function value(e) {
            var t = this.channels.find(function (t) {
              return t.topic === e && (t.isJoined() || t.isJoining());
            });
            t && (this.hasLogger() && this.log("transport", 'leaving duplicate topic "'.concat(e, '"')), t.leave());
          }
        }]), e;
      }(),
          D = function () {
        function e(t) {
          c(this, e), this.endPoint = null, this.token = null, this.skipHeartbeat = !0, this.onopen = function () {}, this.onerror = function () {}, this.onmessage = function () {}, this.onclose = function () {}, this.pollEndpoint = this.normalizeEndpoint(t), this.readyState = p, this.poll();
        }

        return h(e, [{
          key: "normalizeEndpoint",
          value: function value(e) {
            return e.replace("ws://", "http://").replace("wss://", "https://").replace(new RegExp("(.*)/" + x), "$1/" + L);
          }
        }, {
          key: "endpointURL",
          value: function value() {
            return M.appendParams(this.pollEndpoint, {
              token: this.token
            });
          }
        }, {
          key: "closeAndRetry",
          value: function value() {
            this.close(), this.readyState = p;
          }
        }, {
          key: "ontimeout",
          value: function value() {
            this.onerror("timeout"), this.closeAndRetry();
          }
        }, {
          key: "poll",
          value: function value() {
            var e = this;
            this.readyState !== v && this.readyState !== p || M.request("GET", this.endpointURL(), "application/json", null, this.timeout, this.ontimeout.bind(this), function (t) {
              if (t) {
                var n = t.status,
                    i = t.token,
                    o = t.messages;
                e.token = i;
              } else n = 0;

              switch (n) {
                case 200:
                  o.forEach(function (t) {
                    return e.onmessage({
                      data: t
                    });
                  }), e.poll();
                  break;

                case 204:
                  e.poll();
                  break;

                case 410:
                  e.readyState = v, e.onopen(), e.poll();
                  break;

                case 403:
                  e.onerror(), e.close();
                  break;

                case 0:
                case 500:
                  e.onerror(), e.closeAndRetry();
                  break;

                default:
                  throw new Error("unhandled poll status ".concat(n));
              }
            });
          }
        }, {
          key: "send",
          value: function value(e) {
            var t = this;
            M.request("POST", this.endpointURL(), "application/json", e, this.timeout, this.onerror.bind(this, "timeout"), function (e) {
              e && 200 === e.status || (t.onerror(e && e.status), t.closeAndRetry());
            });
          }
        }, {
          key: "close",
          value: function value(e, t) {
            this.readyState = m, this.onclose();
          }
        }]), e;
      }(),
          M = function () {
        function e() {
          c(this, e);
        }

        return h(e, null, [{
          key: "request",
          value: function value(e, t, n, i, o, r, s) {
            if (d.XDomainRequest) {
              var a = new XDomainRequest();
              this.xdomainRequest(a, e, t, i, o, r, s);
            } else {
              var c = new d.XMLHttpRequest();
              this.xhrRequest(c, e, t, n, i, o, r, s);
            }
          }
        }, {
          key: "xdomainRequest",
          value: function value(e, t, n, i, o, r, s) {
            var a = this;
            e.timeout = o, e.open(t, n), e.onload = function () {
              var t = a.parseJSON(e.responseText);
              s && s(t);
            }, r && (e.ontimeout = r), e.onprogress = function () {}, e.send(i);
          }
        }, {
          key: "xhrRequest",
          value: function value(e, t, n, i, o, r, s, a) {
            var c = this;
            e.open(t, n, !0), e.timeout = r, e.setRequestHeader("Content-Type", i), e.onerror = function () {
              a && a(null);
            }, e.onreadystatechange = function () {
              if (e.readyState === c.states.complete && a) {
                var t = c.parseJSON(e.responseText);
                a(t);
              }
            }, s && (e.ontimeout = s), e.send(o);
          }
        }, {
          key: "parseJSON",
          value: function value(e) {
            if (!e || "" === e) return null;

            try {
              return JSON.parse(e);
            } catch (t) {
              return console && console.log("failed to parse JSON response", e), null;
            }
          }
        }, {
          key: "serialize",
          value: function value(e, t) {
            var n = [];

            for (var i in e) {
              if (e.hasOwnProperty(i)) {
                var r = t ? "".concat(t, "[").concat(i, "]") : i,
                    s = e[i];
                "object" === o(s) ? n.push(this.serialize(s, r)) : n.push(encodeURIComponent(r) + "=" + encodeURIComponent(s));
              }
            }

            return n.join("&");
          }
        }, {
          key: "appendParams",
          value: function value(e, t) {
            if (0 === Object.keys(t).length) return e;
            var n = e.match(/\?/) ? "&" : "?";
            return "".concat(e).concat(n).concat(this.serialize(t));
          }
        }]), e;
      }();

      M.states = {
        complete: 4
      };

      var N = function () {
        function e(t) {
          var n = this,
              i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          c(this, e);
          var o = i.events || {
            state: "presence_state",
            diff: "presence_diff"
          };
          this.state = {}, this.pendingDiffs = [], this.channel = t, this.joinRef = null, this.caller = {
            onJoin: function onJoin() {},
            onLeave: function onLeave() {},
            onSync: function onSync() {}
          }, this.channel.on(o.state, function (t) {
            var i = n.caller,
                o = i.onJoin,
                r = i.onLeave,
                s = i.onSync;
            n.joinRef = n.channel.joinRef(), n.state = e.syncState(n.state, t, o, r), n.pendingDiffs.forEach(function (t) {
              n.state = e.syncDiff(n.state, t, o, r);
            }), n.pendingDiffs = [], s();
          }), this.channel.on(o.diff, function (t) {
            var i = n.caller,
                o = i.onJoin,
                r = i.onLeave,
                s = i.onSync;
            n.inPendingSyncState() ? n.pendingDiffs.push(t) : (n.state = e.syncDiff(n.state, t, o, r), s());
          });
        }

        return h(e, [{
          key: "onJoin",
          value: function value(e) {
            this.caller.onJoin = e;
          }
        }, {
          key: "onLeave",
          value: function value(e) {
            this.caller.onLeave = e;
          }
        }, {
          key: "onSync",
          value: function value(e) {
            this.caller.onSync = e;
          }
        }, {
          key: "list",
          value: function value(t) {
            return e.list(this.state, t);
          }
        }, {
          key: "inPendingSyncState",
          value: function value() {
            return !this.joinRef || this.joinRef !== this.channel.joinRef();
          }
        }], [{
          key: "syncState",
          value: function value(e, t, n, i) {
            var o = this,
                r = this.clone(e),
                s = {},
                a = {};
            return this.map(r, function (e, n) {
              t[e] || (a[e] = n);
            }), this.map(t, function (e, t) {
              var n = r[e];

              if (n) {
                var i = t.metas.map(function (e) {
                  return e.phx_ref;
                }),
                    c = n.metas.map(function (e) {
                  return e.phx_ref;
                }),
                    u = t.metas.filter(function (e) {
                  return c.indexOf(e.phx_ref) < 0;
                }),
                    h = n.metas.filter(function (e) {
                  return i.indexOf(e.phx_ref) < 0;
                });
                u.length > 0 && (s[e] = t, s[e].metas = u), h.length > 0 && (a[e] = o.clone(n), a[e].metas = h);
              } else s[e] = t;
            }), this.syncDiff(r, {
              joins: s,
              leaves: a
            }, n, i);
          }
        }, {
          key: "syncDiff",
          value: function value(e, t, n, o) {
            var r = t.joins,
                s = t.leaves,
                a = this.clone(e);
            return n || (n = function n() {}), o || (o = function o() {}), this.map(r, function (e, t) {
              var o = a[e];

              if (a[e] = t, o) {
                var r,
                    s = a[e].metas.map(function (e) {
                  return e.phx_ref;
                }),
                    c = o.metas.filter(function (e) {
                  return s.indexOf(e.phx_ref) < 0;
                });
                (r = a[e].metas).unshift.apply(r, i(c));
              }

              n(e, o, t);
            }), this.map(s, function (e, t) {
              var n = a[e];

              if (n) {
                var i = t.metas.map(function (e) {
                  return e.phx_ref;
                });
                n.metas = n.metas.filter(function (e) {
                  return i.indexOf(e.phx_ref) < 0;
                }), o(e, n, t), 0 === n.metas.length && delete a[e];
              }
            }), a;
          }
        }, {
          key: "list",
          value: function value(e, t) {
            return t || (t = function t(e, _t) {
              return _t;
            }), this.map(e, function (e, n) {
              return t(e, n);
            });
          }
        }, {
          key: "map",
          value: function value(e, t) {
            return Object.getOwnPropertyNames(e).map(function (n) {
              return t(n, e[n]);
            });
          }
        }, {
          key: "clone",
          value: function value(e) {
            return JSON.parse(JSON.stringify(e));
          }
        }]), e;
      }(),
          J = function () {
        function e(t, n) {
          c(this, e), this.callback = t, this.timerCalc = n, this.timer = null, this.tries = 0;
        }

        return h(e, [{
          key: "reset",
          value: function value() {
            this.tries = 0, clearTimeout(this.timer);
          }
        }, {
          key: "scheduleTimeout",
          value: function value() {
            var e = this;
            clearTimeout(this.timer), this.timer = setTimeout(function () {
              e.tries = e.tries + 1, e.callback();
            }, this.timerCalc(this.tries + 1));
          }
        }]), e;
      }();
    }]);
  });
});

function noop() {}

var DEFAULT_BASE_URL = 'https://app.papercups.io';

var isDev = function isDev(w) {
  return Boolean(w.location.hostname === 'localhost' || // [::1] is the IPv6 localhost address.
  w.location.hostname === '[::1]' || // 127.0.0.0/8 are considered localhost for IPv4.
  w.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));
};

var getWebsocketUrl = function getWebsocketUrl() {
  var baseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_BASE_URL;

  // TODO: handle this parsing better
  var _baseUrl$split = baseUrl.split('://'),
      _baseUrl$split2 = _slicedToArray(_baseUrl$split, 2),
      protocol = _baseUrl$split2[0],
      host = _baseUrl$split2[1];

  var isHttps = protocol === 'https'; // TODO: not sure how websockets work with subdomains

  return "".concat(isHttps ? 'wss' : 'ws', "://").concat(host, "/socket");
}; // TODO: handle this on the server instead


function now() {
  var date = new Date();
  return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
}

function shouldActivateGameMode(message) {
  if (!message || !message.length) {
    return false;
  }

  return ['/play2048', '/xyzzy', '/poweroverwhelming', '/howdoyouturnthison', 'what is 2^11', 'what is 2^11?', "what's 2^11", "what's 2^11?"].indexOf(message.toLowerCase()) !== -1;
}

function setupPostMessageHandlers(w, handler) {
  var cb = function cb(msg) {
    handler(msg);
  };

  if (w.addEventListener) {
    w.addEventListener('message', cb);
    return function () {
      return w.removeEventListener('message', cb);
    };
  } else {
    w.attachEvent('onmessage', cb);
    return function () {
      return w.detachEvent('onmessage', cb);
    };
  }
}

var setupCustomEventHandlers = function setupCustomEventHandlers(w, events, handlers) {
  if (w.addEventListener) {
    var _iterator = _createForOfIteratorHelper(events),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var event = _step.value;
        w.addEventListener(event, handlers);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return function () {
      return events.map(function (event) {
        return w.removeEventListener(event, handlers);
      });
    };
  } else {
    console.error('Custom events are not supported in your browser!');
    return noop;
  }
};

var isCustomerMessage = function isCustomerMessage(message, customerId) {
  return message.customer_id === customerId || !!message.sent_at && message.type === 'customer';
};

var isAgentMessage = function isAgentMessage(message) {
  var agentId = message.user_id,
      messageType = message.type;
  return !!agentId || messageType === 'bot';
};

var areDatesEqual = function areDatesEqual(x, y) {
  if (!x || !y) {
    return false;
  }

  return Math.floor(+new Date(x) / 1000) === Math.floor(+new Date(y) / 1000);
};

var isValidUuid = function isValidUuid(id) {
  if (!id || !id.length) {
    return false;
  }

  var regex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return regex.test(id);
};

var bind = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);

    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    return fn.apply(thisArg, args);
  };
};
/*global toString:true*/
// utils is a library of generic helper functions non-specific to axios


var toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */

function isArray(val) {
  return toString.call(val) === '[object Array]';
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */


function isUndefined(val) {
  return typeof val === 'undefined';
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */


function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */


function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */


function isFormData(val) {
  return typeof FormData !== 'undefined' && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */


function isArrayBufferView(val) {
  var result;

  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && val.buffer instanceof ArrayBuffer;
  }

  return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */


function isString(val) {
  return typeof val === 'string';
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */


function isNumber(val) {
  return typeof val === 'number';
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */


function isObject(val) {
  return val !== null && typeof val === 'object';
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */


function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */


function isDate(val) {
  return toString.call(val) === '[object Date]';
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */


function isFile(val) {
  return toString.call(val) === '[object File]';
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */


function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */


function isFunction(val) {
  return toString.call(val) === '[object Function]';
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */


function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */


function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */


function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */


function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) {
    return false;
  }

  return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */


function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  } // Force an array if not already something iterable


  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */


function
  /* obj1, obj2, obj3, ... */
merge() {
  var result = {};

  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }

  return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */


function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */


function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }

  return content;
}

var utils = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};

function encode(val) {
  return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */


var buildURL = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;

  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];
    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }

        parts.push(encode(key) + '=' + encode(v));
      });
    });
    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');

    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

function InterceptorManager() {
  this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */


InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */


InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */


InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

var InterceptorManager_1 = InterceptorManager;
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */

var transformData = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });
  return data;
};

var isCancel = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

var normalizeHeaderName = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */


var enhanceError = function enhanceError(error, config, code, request, response) {
  error.config = config;

  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };

  return error;
};
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */


var createError = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */


var settle = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;

  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError('Request failed with status code ' + response.status, response.config, null, response.request, response));
  }
};

var cookies = utils.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
  return {
    write: function write(name, value, expires, path, domain, secure) {
      var cookie = [];
      cookie.push(name + '=' + encodeURIComponent(value));

      if (utils.isNumber(expires)) {
        cookie.push('expires=' + new Date(expires).toGMTString());
      }

      if (utils.isString(path)) {
        cookie.push('path=' + path);
      }

      if (utils.isString(domain)) {
        cookie.push('domain=' + domain);
      }

      if (secure === true) {
        cookie.push('secure');
      }

      document.cookie = cookie.join('; ');
    },
    read: function read(name) {
      var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
      return match ? decodeURIComponent(match[3]) : null;
    },
    remove: function remove(name) {
      this.write(name, '', Date.now() - 86400000);
    }
  };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return {
    write: function write() {},
    read: function read() {
      return null;
    },
    remove: function remove() {}
  };
}();
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */

var isAbsoluteURL = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */


var combineURLs = function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */


var buildFullPath = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }

  return requestedURL;
}; // Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers


var ignoreDuplicateOf = ['age', 'authorization', 'content-length', 'content-type', 'etag', 'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since', 'last-modified', 'location', 'max-forwards', 'proxy-authorization', 'referer', 'retry-after', 'user-agent'];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */

var parseHeaders = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) {
    return parsed;
  }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }

      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });
  return parsed;
};

var isURLSameOrigin = utils.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
  var msie = /(msie|trident)/i.test(navigator.userAgent);
  var urlParsingNode = document.createElement('a');
  var originURL;
  /**
  * Parse a URL to discover it's components
  *
  * @param {String} url The URL to be parsed
  * @returns {Object}
  */

  function resolveURL(url) {
    var href = url;

    if (msie) {
      // IE needs attribute set twice to normalize properties
      urlParsingNode.setAttribute('href', href);
      href = urlParsingNode.href;
    }

    urlParsingNode.setAttribute('href', href); // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils

    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
      hostname: urlParsingNode.hostname,
      port: urlParsingNode.port,
      pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
    };
  }

  originURL = resolveURL(window.location.href);
  /**
  * Determine if a URL shares the same origin as the current location
  *
  * @param {String} requestURL The URL to test
  * @returns {boolean} True if URL shares the same origin, otherwise false
  */

  return function isURLSameOrigin(requestURL) {
    var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
  };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return function isURLSameOrigin() {
    return true;
  };
}();

var xhr = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest(); // HTTP basic authentication

    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true); // Set the request timeout in MS

    request.timeout = config.timeout; // Listen for ready state

    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      } // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request


      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      } // Prepare the response


      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };
      settle(resolve, reject, response); // Clean up request

      request = null;
    }; // Handle browser request cancellation (as opposed to a manual cancellation)


    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request)); // Clean up request

      request = null;
    }; // Handle low level network errors


    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request)); // Clean up request

      request = null;
    }; // Handle timeout


    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';

      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }

      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED', request)); // Clean up request

      request = null;
    }; // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.


    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    } // Add headers to the request


    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    } // Add withCredentials to request if needed


    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    } // Add responseType to request if needed


    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    } // Handle progress if needed


    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    } // Not all browsers support upload events


    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel); // Clean up request

        request = null;
      });
    }

    if (!requestData) {
      requestData = null;
    } // Send the request


    request.send(requestData);
  });
};

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;

  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = xhr;
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = xhr;
  }

  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),
  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) {
      return data;
    }

    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }

    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }

    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }

    return data;
  }],
  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) {
        /* Ignore */
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',
  maxContentLength: -1,
  maxBodyLength: -1,
  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};
defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};
utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});
utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});
var defaults_1 = defaults;
/**
 * Throws a `Cancel` if cancellation has been requested.
 */

function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */


var dispatchRequest = function dispatchRequest(config) {
  throwIfCancellationRequested(config); // Ensure headers exist

  config.headers = config.headers || {}; // Transform request data

  config.data = transformData(config.data, config.headers, config.transformRequest); // Flatten headers

  config.headers = utils.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
  utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], function cleanHeaderConfig(method) {
    delete config.headers[method];
  });
  var adapter = config.adapter || defaults_1.adapter;
  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config); // Transform response data

    response.data = transformData(response.data, response.headers, config.transformResponse);
    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config); // Transform response data

      if (reason && reason.response) {
        reason.response.data = transformData(reason.response.data, reason.response.headers, config.transformResponse);
      }
    }

    return Promise.reject(reason);
  });
};
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */


var mergeConfig = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};
  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = ['baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer', 'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName', 'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress', 'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent', 'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'];
  var directMergeKeys = ['validateStatus'];

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }

    return source;
  }

  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });
  utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });
  utils.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });
  var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys);
  var otherKeys = Object.keys(config1).concat(Object.keys(config2)).filter(function filterAxiosKeys(key) {
    return axiosKeys.indexOf(key) === -1;
  });
  utils.forEach(otherKeys, mergeDeepProperties);
  return config;
};
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */


function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager_1(),
    response: new InterceptorManager_1()
  };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */


Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config); // Set config.method

  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  } // Hook up interceptors middleware


  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
}; // Provide aliases for supported request methods


utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function (url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});
utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function (url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});
var Axios_1 = Axios;
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */

function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;
var Cancel_1 = Cancel;
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */

function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });
  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel_1(message);
    resolvePromise(token.reason);
  });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */


CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */


CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

var CancelToken_1 = CancelToken;
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */

var spread = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */


var isAxiosError = function isAxiosError(payload) {
  return typeof payload === 'object' && payload.isAxiosError === true;
};
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */


function createInstance(defaultConfig) {
  var context = new Axios_1(defaultConfig);
  var instance = bind(Axios_1.prototype.request, context); // Copy axios.prototype to instance

  utils.extend(instance, Axios_1.prototype, context); // Copy context to instance

  utils.extend(instance, context);
  return instance;
} // Create the default instance to be exported


var axios$1 = createInstance(defaults_1); // Expose Axios class to allow class inheritance

axios$1.Axios = Axios_1; // Factory for creating new instances

axios$1.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios$1.defaults, instanceConfig));
}; // Expose Cancel & CancelToken


axios$1.Cancel = Cancel_1;
axios$1.CancelToken = CancelToken_1;
axios$1.isCancel = isCancel; // Expose all/spread

axios$1.all = function all(promises) {
  return Promise.all(promises);
};

axios$1.spread = spread; // Expose isAxiosError

axios$1.isAxiosError = isAxiosError;
var axios_1 = axios$1; // Allow use of default import syntax in TypeScript

var _default = axios$1;
axios_1.default = _default;
var axios = axios_1;
var EMPTY_METADATA = {};

var get = function get(url) {
  var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", axios.get(url, {
              params: query
            }).then(function (res) {
              return res.data.data;
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};

var post = function post(url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", axios.post(url, params).then(function (res) {
              return res.data.data;
            }));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
};

var put = function put(url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", axios.put(url, params).then(function (res) {
              return res.data.data;
            }));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
};

var fetchWidgetSettings = function fetchWidgetSettings(query) {
  var baseUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_BASE_URL;
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", get("".concat(baseUrl, "/api/widget_settings"), query));

          case 1:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
};

var updateWidgetSettingsMetadata = function updateWidgetSettingsMetadata(params) {
  var baseUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_BASE_URL;
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", put("".concat(baseUrl, "/api/widget_settings/metadata"), params));

          case 1:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
};

var createNewCustomer = function createNewCustomer(accountId) {
  var metadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPTY_METADATA;
  var baseUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_BASE_URL;
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt("return", post("".concat(baseUrl, "/api/customers"), {
              customer: Object.assign(Object.assign({}, metadata), {
                account_id: accountId,
                // TODO: handle on the server instead!
                first_seen: now(),
                last_seen: now()
              })
            }));

          case 1:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
};

var isValidCustomer = function isValidCustomer(customerId, accountId) {
  var baseUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_BASE_URL;
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            return _context7.abrupt("return", get("".concat(baseUrl, "/api/customers/").concat(customerId, "/exists"), {
              account_id: accountId
            }));

          case 1:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
};

var updateCustomerMetadata = function updateCustomerMetadata(customerId) {
  var metadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPTY_METADATA;
  var baseUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_BASE_URL;
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            return _context8.abrupt("return", put("".concat(baseUrl, "/api/customers/").concat(customerId, "/metadata"), {
              metadata: metadata
            }));

          case 1:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
};

var createNewConversation = function createNewConversation(conversation) {
  var baseUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_BASE_URL;
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            return _context9.abrupt("return", post("".concat(baseUrl, "/api/conversations"), {
              conversation: conversation
            }));

          case 1:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
};

var findCustomerByExternalId = function findCustomerByExternalId(query) {
  var baseUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_BASE_URL;
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            return _context10.abrupt("return", get("".concat(baseUrl, "/api/customers/identify"), query));

          case 1:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
};

var fetchCustomerConversations = function fetchCustomerConversations(query) {
  var baseUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_BASE_URL;
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            return _context11.abrupt("return", get("".concat(baseUrl, "/api/conversations/customer"), query));

          case 1:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
};

var upload = function upload(params) {
  var baseUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_BASE_URL;
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            return _context12.abrupt("return", post("".concat(baseUrl, "/api/upload"), params));

          case 1:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));
};

var Logger = /*#__PURE__*/function () {
  function Logger(debugModeEnabled) {
    _classCallCheck(this, Logger);

    this.debugModeEnabled = !!debugModeEnabled;
  }

  _createClass(Logger, [{
    key: "debug",
    value: function debug() {
      var _console;

      if (!this.debugModeEnabled) {
        return;
      }

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      (_console = console).debug.apply(_console, ['[@papercups/browser]'].concat(args));
    }
  }, {
    key: "log",
    value: function log() {
      var _console2;

      if (!this.debugModeEnabled) {
        return;
      }

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      (_console2 = console).log.apply(_console2, ['[@papercups/browser]'].concat(args));
    }
  }, {
    key: "info",
    value: function info() {
      var _console3;

      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      (_console3 = console).info.apply(_console3, ['[@papercups/browser]'].concat(args));
    }
  }, {
    key: "warn",
    value: function warn() {
      var _console4;

      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      (_console4 = console).warn.apply(_console4, ['[@papercups/browser]'].concat(args));
    }
  }, {
    key: "error",
    value: function error() {
      var _console5;

      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      (_console5 = console).error.apply(_console5, ['[@papercups/browser]'].concat(args));
    }
  }]);

  return Logger;
}(); // TODO: do something different for dev vs prod


var PREFIX = '__PAPERCUPS__'; // FIXME: this is just a workaround until we can stop
// relying on localStorage in our chat iframe

var getStorage = function getStorage(w) {
  try {
    var storage = w && (w.localStorage || w.sessionStorage);
    return storage;
  } catch (e) {
    return {
      _db: {},
      getItem: function getItem(key) {
        return this._db[key] || null;
      },
      setItem: function setItem(key, value) {
        this._db[key] = value;
      },
      removeItem: function removeItem(key) {
        delete this._db[key];
      }
    };
  }
};

function store(w) {
  var storage = getStorage(w);

  var get = function get(key) {
    var result = storage.getItem("".concat(PREFIX).concat(key));

    if (!result) {
      return null;
    }

    try {
      return JSON.parse(result);
    } catch (e) {
      return result;
    }
  };

  var set = function set(key, value) {
    storage.setItem("".concat(PREFIX).concat(key), JSON.stringify(value));
  };

  var remove = function remove(key) {
    storage.removeItem(key);
  }; // TODO: improve these names


  return {
    getCustomerId: function getCustomerId() {
      return get('__CUSTOMER_ID__');
    },
    setCustomerId: function setCustomerId(id) {
      return set('__CUSTOMER_ID__', id);
    },
    removeCustomerId: function removeCustomerId() {
      return remove('__CUSTOMER_ID__');
    }
  };
} // TODO: split into smaller modules? (e.g. decouple socket/channel from other logic)


var Papercups = /*#__PURE__*/_createClass(function Papercups(config) {
  var _this = this;

  _classCallCheck(this, Papercups);

  this.start = function () {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
      var settings, isValidCustomer, validatedCustomerId, metadata, customerId;
      return _regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              this.connect();
              _context13.next = 3;
              return this.fetchWidgetSettings();

            case 3:
              settings = _context13.sent;
              _context13.next = 6;
              return this.isValidCustomerId(this.customerId);

            case 6:
              isValidCustomer = _context13.sent;
              validatedCustomerId = isValidCustomer ? this.customerId : null;
              metadata = this.config.customer || {};
              _context13.next = 11;
              return this.checkForExistingCustomer(metadata, validatedCustomerId);

            case 11:
              customerId = _context13.sent;
              return _context13.abrupt("return", this.setWidgetSettings(settings).setCustomerId(customerId).fetchLatestConversation(customerId));

            case 13:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13, this);
    }));
  };

  this.connect = function () {
    _this.socket.connect();

    _this.listenForAgentAvailability();
  };

  this.disconnect = function () {
    var _a;

    _this.socket.disconnect();

    (_a = _this.channel) === null || _a === void 0 ? void 0 : _a.leave();
  };

  this.setWidgetSettings = function (settings) {
    _this.settings = settings;

    if (_this.config.onSetWidgetSettings) {
      _this.config.onSetWidgetSettings(settings);
    }

    return _this;
  };

  this.setCustomerId = function (customerId) {
    _this.logger.debug('Setting customer ID:', customerId);

    _this.customerId = customerId;

    _this.cacheCustomerId(customerId); // Let other modules know that the customer has been set?


    window.dispatchEvent(new CustomEvent('papercups:customer:set', {
      detail: customerId
    }));

    if (_this.config.onSetCustomerId) {
      _this.logger.debug('Invoking onSetCustomerId:', customerId);

      _this.config.onSetCustomerId(customerId);
    }

    return _this;
  };

  this.setConversationId = function (conversationId) {
    _this.conversationId = conversationId; // TODO: should this be handled explicitly instead?

    _this.joinConversationChannel(conversationId);

    if (_this.config.onSetConversationId) {
      _this.config.onSetConversationId(conversationId);
    }

    return _this;
  };

  this.setMessages = function (messages) {
    _this.messages = messages;

    if (_this.config.onMessagesUpdated) {
      _this.config.onMessagesUpdated(messages);
    }

    return _this;
  };

  this.listenForAgentAvailability = function () {
    var accountId = _this.config.accountId;

    var room = _this.socket.channel("room:".concat(accountId), {});

    room.join().receive('ok', function (res) {
      _this.logger.debug('Joined room successfully!', res);
    }).receive('error', function (err) {
      _this.logger.debug('Unable to join room!', err);
    });
    var presence = new phoenix.Presence(room);
    presence.onSync(function () {
      _this.logger.debug('Syncing presence:', presence.list());

      _this.config.onPresenceSync && _this.config.onPresenceSync(presence);
    });
    return _this;
  };

  this.listenForNewConversations = function (customerId) {
    var channel = _this.socket.channel("conversation:lobby:".concat(customerId), {}); // TODO: what does this data look like?


    channel.on('conversation:created', function (data) {
      _this.config.onConversationCreated && _this.config.onConversationCreated(customerId, data); // TODO: is the setTimeout still necessary? it shouldn't be...

      setTimeout(function () {
        return _this.fetchLatestConversation(customerId);
      }, 1000);
    });
    channel.join().receive('ok', function (res) {
      _this.logger.debug('Successfully listening for new conversations!', res);
    }).receive('error', function (err) {
      _this.logger.debug('Unable to listen for new conversations!', err);
    });
    return _this;
  };

  this.joinConversationChannel = function (conversationId, fallbackCustomerId) {
    if (_this.channel && _this.channel.leave) {
      _this.channel.leave(); // TODO: what's the best practice here?

    }

    var customerId = _this.customerId || fallbackCustomerId;

    _this.logger.debug('Joining channel:', conversationId);

    _this.channel = _this.socket.channel("conversation:".concat(conversationId), {
      customer_id: customerId
    });

    _this.channel.on('shout', function (message) {
      _this.handleMessageCreated(message);

      _this.config.onMessageCreated && _this.config.onMessageCreated(message);
    });

    _this.channel.join().receive('ok', function (res) {
      _this.logger.debug('Joined conversation successfully!', res);
    }).receive('error', function (err) {
      _this.logger.debug('Unable to join conversation!', err);
    });

    return _this;
  };

  this.createNewConversation = function (customerId) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
      var _this$config, accountId, inboxId, baseUrl, params;

      return _regeneratorRuntime.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              _this$config = this.config, accountId = _this$config.accountId, inboxId = _this$config.inboxId, baseUrl = _this$config.baseUrl;
              params = {
                account_id: accountId,
                customer_id: customerId,
                inbox_id: inboxId
              };
              return _context14.abrupt("return", createNewConversation(params, baseUrl));

            case 3:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14, this);
    }));
  };

  this.initializeNewConversation = function (existingCustomerId, email) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
      var _this$config$customer, customer, metadata, customerId, _yield$this$createNew, conversationId;

      return _regeneratorRuntime.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              _this$config$customer = this.config.customer, customer = _this$config$customer === void 0 ? {} : _this$config$customer;
              metadata = email ? Object.assign(Object.assign({}, customer), {
                email: email
              }) : customer;
              _context15.next = 4;
              return this.createOrUpdateCustomer(existingCustomerId, metadata);

            case 4:
              customerId = _context15.sent;
              _context15.next = 7;
              return this.createNewConversation(customerId);

            case 7:
              _yield$this$createNew = _context15.sent;
              conversationId = _yield$this$createNew.id;
              return _context15.abrupt("return", this.setCustomerId(customerId).setConversationId(conversationId));

            case 10:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15, this);
    }));
  };

  this.updateCustomerMetadata = function (customerId, metadata) {
    _this.logger.debug('Updating customer metadata:', {
      customerId: customerId,
      metadata: metadata
    });

    var baseUrl = _this.config.baseUrl;
    return updateCustomerMetadata(customerId, metadata, baseUrl);
  };

  this.createNewCustomer = function (customer) {
    _this.logger.debug('Creating new customer:', customer);

    var _this$config2 = _this.config,
        baseUrl = _this$config2.baseUrl,
        accountId = _this$config2.accountId;
    return createNewCustomer(accountId, customer, baseUrl);
  };

  this.identify = function (externalId) {
    var metadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
      var id, _isValidCustomer, params, _yield$this$updateCus, _customerId2, existingCustomerId, _ref, _customerId, _yield$this$createNew2, _customerId3;

      return _regeneratorRuntime.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              _context16.prev = 0;
              id = this.customerId || this.getCachedCustomerId();
              _context16.next = 4;
              return this.isValidCustomerId(id);

            case 4:
              _isValidCustomer = _context16.sent;
              params = Object.assign(Object.assign({}, metadata), {
                external_id: externalId
              });

              if (!_isValidCustomer) {
                _context16.next = 13;
                break;
              }

              this.logger.debug('Valid customer found for ID:', id);
              _context16.next = 10;
              return this.updateCustomerMetadata(id, params);

            case 10:
              _yield$this$updateCus = _context16.sent;
              _customerId2 = _yield$this$updateCus.id;
              return _context16.abrupt("return", this.setCustomerId(_customerId2));

            case 13:
              _context16.next = 15;
              return this.checkForExistingCustomer(params);

            case 15:
              existingCustomerId = _context16.sent;

              if (!existingCustomerId) {
                _context16.next = 22;
                break;
              }

              _context16.next = 19;
              return this.updateCustomerMetadata(existingCustomerId, params);

            case 19:
              _context16.t0 = _context16.sent;
              _context16.next = 25;
              break;

            case 22:
              _context16.next = 24;
              return this.createNewCustomer(params);

            case 24:
              _context16.t0 = _context16.sent;

            case 25:
              _ref = _context16.t0;
              _customerId = _ref.id;
              return _context16.abrupt("return", this.setCustomerId(_customerId));

            case 30:
              _context16.prev = 30;
              _context16.t1 = _context16["catch"](0);
              // TODO: this edge case may occur if the cached customer ID somehow
              // gets messed up (e.g. between dev and prod environments). The long term
              // fix should be changing the cache key for different environments.
              this.logger.error('Failed to update or create customer:', _context16.t1);
              this.logger.error('Retrying...');
              _context16.next = 36;
              return this.createNewCustomer(metadata);

            case 36:
              _yield$this$createNew2 = _context16.sent;
              _customerId3 = _yield$this$createNew2.id;
              return _context16.abrupt("return", this.setCustomerId(_customerId3));

            case 39:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16, this, [[0, 30]]);
    }));
  }; // This is very similar to `identify` above, but only used internally


  this.createOrUpdateCustomer = function (existingCustomerId) {
    var metadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
      var customer, _customerId4, _yield$this$createNew3, _customerId5;

      return _regeneratorRuntime.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              _context17.prev = 0;

              if (!existingCustomerId) {
                _context17.next = 7;
                break;
              }

              _context17.next = 4;
              return this.updateCustomerMetadata(existingCustomerId, metadata);

            case 4:
              _context17.t0 = _context17.sent;
              _context17.next = 10;
              break;

            case 7:
              _context17.next = 9;
              return this.createNewCustomer(metadata);

            case 9:
              _context17.t0 = _context17.sent;

            case 10:
              customer = _context17.t0;
              _customerId4 = customer.id;
              return _context17.abrupt("return", _customerId4);

            case 15:
              _context17.prev = 15;
              _context17.t1 = _context17["catch"](0);
              // TODO: this edge case may occur if the cached customer ID somehow
              // gets messed up (e.g. between dev and prod environments). The long term
              // fix should be changing the cache key for different environments.
              this.logger.error('Failed to update or create customer:', _context17.t1);
              this.logger.error('Retrying...');
              _context17.next = 21;
              return this.createNewCustomer(metadata);

            case 21:
              _yield$this$createNew3 = _context17.sent;
              _customerId5 = _yield$this$createNew3.id;
              return _context17.abrupt("return", _customerId5);

            case 24:
            case "end":
              return _context17.stop();
          }
        }
      }, _callee17, this, [[0, 15]]);
    }));
  };

  this.fetchWidgetSettings = function () {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee18() {
      var _this$config3, accountId, inboxId, baseUrl, query, empty;

      return _regeneratorRuntime.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              _this$config3 = this.config, accountId = _this$config3.accountId, inboxId = _this$config3.inboxId, baseUrl = _this$config3.baseUrl;
              query = {
                account_id: accountId,
                inbox_id: inboxId
              };
              empty = {};
              return _context18.abrupt("return", fetchWidgetSettings(query, baseUrl).then(function (settings) {
                return settings || empty;
              }).catch(function () {
                return empty;
              }));

            case 4:
            case "end":
              return _context18.stop();
          }
        }
      }, _callee18, this);
    }));
  };

  this.updateWidgetSettingsMetadata = function (metadata) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
      var _this2 = this;

      var _this$config4, accountId, inboxId, baseUrl, params;

      return _regeneratorRuntime.wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              _this$config4 = this.config, accountId = _this$config4.accountId, inboxId = _this$config4.inboxId, baseUrl = _this$config4.baseUrl;
              params = {
                account_id: accountId,
                inbox_id: inboxId,
                metadata: metadata
              };
              return _context19.abrupt("return", updateWidgetSettingsMetadata(params, baseUrl).catch(function (err) {
                // No need to block on this
                _this2.logger.error('Failed to update widget metadata:', err);
              }));

            case 3:
            case "end":
              return _context19.stop();
          }
        }
      }, _callee19, this);
    }));
  };

  this.findCustomerByExternalId = function (externalId) {
    var filters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
      var _this$config5, accountId, baseUrl, query, _yield$findCustomerBy, matchingCustomerId;

      return _regeneratorRuntime.wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              _this$config5 = this.config, accountId = _this$config5.accountId, baseUrl = _this$config5.baseUrl;
              query = Object.assign({
                account_id: accountId,
                external_id: externalId
              }, filters);
              _context20.next = 4;
              return findCustomerByExternalId(query, baseUrl);

            case 4:
              _yield$findCustomerBy = _context20.sent;
              matchingCustomerId = _yield$findCustomerBy.customer_id;
              return _context20.abrupt("return", matchingCustomerId);

            case 7:
            case "end":
              return _context20.stop();
          }
        }
      }, _callee20, this);
    }));
  };

  this.findCustomerByMetadata = function (metadata) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee21() {
      var email, host, externalId, filters, customerId;
      return _regeneratorRuntime.wrap(function _callee21$(_context21) {
        while (1) {
          switch (_context21.prev = _context21.next) {
            case 0:
              if (!(!metadata || !(metadata === null || metadata === void 0 ? void 0 : metadata.external_id))) {
                _context21.next = 2;
                break;
              }

              return _context21.abrupt("return", null);

            case 2:
              // NB: we check for matching existing customers based on external_id, email,
              // and host -- this may break across subdomains, but I think this is fine for now.
              email = metadata.email, host = metadata.host, externalId = metadata.external_id;
              filters = {
                email: email,
                host: host
              };
              _context21.next = 6;
              return this.findCustomerByExternalId(externalId, filters);

            case 6:
              customerId = _context21.sent;
              return _context21.abrupt("return", customerId);

            case 8:
            case "end":
              return _context21.stop();
          }
        }
      }, _callee21, this);
    }));
  };

  this.checkForExistingCustomer = function (metadata) {
    var defaultCustomerId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee22() {
      var matchingCustomerId;
      return _regeneratorRuntime.wrap(function _callee22$(_context22) {
        while (1) {
          switch (_context22.prev = _context22.next) {
            case 0:
              if (!(!metadata || !(metadata === null || metadata === void 0 ? void 0 : metadata.external_id))) {
                _context22.next = 2;
                break;
              }

              return _context22.abrupt("return", defaultCustomerId);

            case 2:
              _context22.next = 4;
              return this.findCustomerByMetadata(metadata);

            case 4:
              matchingCustomerId = _context22.sent;

              if (matchingCustomerId) {
                _context22.next = 9;
                break;
              }

              return _context22.abrupt("return", null);

            case 9:
              if (!(matchingCustomerId === defaultCustomerId)) {
                _context22.next = 13;
                break;
              }

              return _context22.abrupt("return", defaultCustomerId);

            case 13:
              return _context22.abrupt("return", matchingCustomerId);

            case 14:
            case "end":
              return _context22.stop();
          }
        }
      }, _callee22, this);
    }));
  };

  this.updateExistingCustomer = function (customerId, metadata) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee23() {
      return _regeneratorRuntime.wrap(function _callee23$(_context23) {
        while (1) {
          switch (_context23.prev = _context23.next) {
            case 0:
              if (metadata) {
                _context23.next = 2;
                break;
              }

              return _context23.abrupt("return");

            case 2:
              _context23.prev = 2;
              _context23.next = 5;
              return this.updateCustomerMetadata(customerId, metadata);

            case 5:
              _context23.next = 10;
              break;

            case 7:
              _context23.prev = 7;
              _context23.t0 = _context23["catch"](2);
              this.logger.debug('Error updating customer metadata!', _context23.t0);

            case 10:
            case "end":
              return _context23.stop();
          }
        }
      }, _callee23, this, [[2, 7]]);
    }));
  };

  this.fetchLatestCustomerConversation = function (customerId) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee24() {
      var _this3 = this;

      var _this$config6, accountId, inboxId, baseUrl, query;

      return _regeneratorRuntime.wrap(function _callee24$(_context24) {
        while (1) {
          switch (_context24.prev = _context24.next) {
            case 0:
              _this$config6 = this.config, accountId = _this$config6.accountId, inboxId = _this$config6.inboxId, baseUrl = _this$config6.baseUrl;
              query = {
                customer_id: customerId,
                account_id: accountId,
                inbox_id: inboxId
              };
              return _context24.abrupt("return", fetchCustomerConversations(query, baseUrl).then(function (conversations) {
                _this3.logger.debug('Found existing conversations:', conversations);

                var _conversations = _slicedToArray(conversations, 1),
                    latest = _conversations[0];

                return latest || null;
              }));

            case 3:
            case "end":
              return _context24.stop();
          }
        }
      }, _callee24, this);
    }));
  };

  this.getCachedCustomerId = function () {
    return _this.storage.getCustomerId();
  };

  this.cacheCustomerId = function (customerId) {
    _this.logger.debug('Caching customer ID:', customerId);

    if (!customerId) {
      _this.storage.removeCustomerId();
    } else {
      // TODO: don't depend on storage working? (also add support for local/session/cookies)
      _this.storage.setCustomerId(customerId);
    }
  };

  this.markMessagesAsSeen = function () {
    var _a;

    (_a = _this.channel) === null || _a === void 0 ? void 0 : _a.push('messages:seen', {});

    var messages = _this.messages.map(function (msg) {
      return msg.seen_at ? msg : Object.assign(Object.assign({}, msg), {
        seen_at: new Date().toISOString()
      });
    });

    _this.setMessages(messages);
  };

  this.sendNewMessage = function (message, email) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee25() {
      var _a, customerId, conversationId, _message$body, body, _message$file_ids, file_ids, isMissingBody, isMissingAttachments, isInvalidMessage, sentAt, payload;

      return _regeneratorRuntime.wrap(function _callee25$(_context25) {
        while (1) {
          switch (_context25.prev = _context25.next) {
            case 0:
              customerId = this.customerId, conversationId = this.conversationId;
              _message$body = message.body, body = _message$body === void 0 ? '' : _message$body, _message$file_ids = message.file_ids, file_ids = _message$file_ids === void 0 ? [] : _message$file_ids;
              isMissingBody = !body || body.trim().length === 0;
              isMissingAttachments = !file_ids || file_ids.length === 0;
              isInvalidMessage = isMissingBody && isMissingAttachments; // TODO: how should we handle no channel connected?

              if (!isInvalidMessage) {
                _context25.next = 7;
                break;
              }

              return _context25.abrupt("return");

            case 7:
              // TODO: this seems to be unreliable
              sentAt = new Date().toISOString(); // TODO: figure out how this should work if `customerId` is null

              payload = Object.assign(Object.assign({}, message), {
                body: body,
                customer_id: customerId,
                type: 'customer',
                sent_at: sentAt
              }); // Optimistic update?

              this.setMessages([].concat(_toConsumableArray(this.messages), [payload]));

              if (!(!customerId || !conversationId)) {
                _context25.next = 13;
                break;
              }

              _context25.next = 13;
              return this.initializeNewConversation(customerId, email);

            case 13:
              (_a = this.channel) === null || _a === void 0 ? void 0 : _a.push('shout', Object.assign(Object.assign({}, message), {
                body: body,
                customer_id: this.customerId,
                sent_at: sentAt
              }));

            case 14:
            case "end":
              return _context25.stop();
          }
        }
      }, _callee25, this);
    }));
  };

  this.handleMessageCreated = function (message) {
    var _this$messages = _this.messages,
        messages = _this$messages === void 0 ? [] : _this$messages;
    var unsent = messages.find(function (m) {
      return !m.created_at && areDatesEqual(m.sent_at, message.sent_at) && (m.body === message.body || !m.body && !message.body);
    });
    var updated = unsent ? messages.map(function (m) {
      return m.sent_at === unsent.sent_at ? message : m;
    }) : [].concat(_toConsumableArray(messages), [message]);

    _this.setMessages(updated);
  };

  this.isValidCustomer = function (customerId) {
    var _this$config7 = _this.config,
        baseUrl = _this$config7.baseUrl,
        accountId = _this$config7.accountId;
    return isValidCustomer(customerId, accountId, baseUrl);
  };

  this.isValidCustomerId = function (customerId) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee26() {
      var _isValidCustomer2;

      return _regeneratorRuntime.wrap(function _callee26$(_context26) {
        while (1) {
          switch (_context26.prev = _context26.next) {
            case 0:
              if (!(!customerId || !customerId.length)) {
                _context26.next = 2;
                break;
              }

              return _context26.abrupt("return", false);

            case 2:
              if (isValidUuid(customerId)) {
                _context26.next = 4;
                break;
              }

              return _context26.abrupt("return", false);

            case 4:
              _context26.prev = 4;
              _context26.next = 7;
              return this.isValidCustomer(customerId);

            case 7:
              _isValidCustomer2 = _context26.sent;
              return _context26.abrupt("return", _isValidCustomer2);

            case 11:
              _context26.prev = 11;
              _context26.t0 = _context26["catch"](4);
              this.logger.warn('Failed to validate customer ID.');
              this.logger.warn('You might be on an older version of Papercups.'); // Return true for backwards compatibility

              return _context26.abrupt("return", true);

            case 16:
            case "end":
              return _context26.stop();
          }
        }
      }, _callee26, this, [[4, 11]]);
    }));
  };

  this.formatCustomerMetadata = function () {
    var _this$config$customer2 = _this.config.customer,
        customer = _this$config$customer2 === void 0 ? {} : _this$config$customer2;

    if (!customer) {
      return {};
    }

    return Object.keys(customer).reduce(function (acc, key) {
      if (key === 'metadata') {
        return Object.assign(Object.assign({}, acc), _defineProperty({}, key, customer[key]));
      } else {
        // Make sure all other passed-in values are strings
        return Object.assign(Object.assign({}, acc), _defineProperty({}, key, String(customer[key])));
      }
    }, {});
  };

  this.getDefaultGreeting = function () {
    var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _a, _b;

    if (_this.config.setInitialMessage) {
      return _this.config.setInitialMessage(overrides);
    }

    var greeting = _this.config.greeting || _this.settings.greeting;
    var awayMessage = _this.config.awayMessage || _this.settings.away_message;

    if (!greeting && !awayMessage) {
      return [];
    }

    var hasAwayMessage = awayMessage && awayMessage.length > 0;
    var isOutsideWorkingHours = !!((_b = (_a = _this.settings) === null || _a === void 0 ? void 0 : _a.account) === null || _b === void 0 ? void 0 : _b.is_outside_working_hours);
    var shouldDisplayAwayMessage = hasAwayMessage && isOutsideWorkingHours;
    return [Object.assign({
      type: 'bot',
      customer_id: 'bot',
      body: shouldDisplayAwayMessage ? awayMessage : greeting,
      created_at: new Date().toISOString()
    }, overrides)];
  };

  this.fetchLatestConversation = function () {
    var fallbackCustomerId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee27() {
      var _customerId6, conversation, conversationId, _conversation$message, messages, formattedMessages, _formattedMessages, initialMessage, initialMessageCreatedAt;

      return _regeneratorRuntime.wrap(function _callee27$(_context27) {
        while (1) {
          switch (_context27.prev = _context27.next) {
            case 0:
              _context27.prev = 0;
              _customerId6 = this.customerId || fallbackCustomerId;

              if (_customerId6) {
                _context27.next = 5;
                break;
              }

              // If there's no customerId, we haven't seen this customer before,
              // so do nothing until they try to create a new message
              this.setMessages(_toConsumableArray(this.getDefaultGreeting()));
              return _context27.abrupt("return", null);

            case 5:
              this.logger.debug('Fetching conversations for customer:', _customerId6);
              _context27.next = 8;
              return this.fetchLatestCustomerConversation(_customerId6);

            case 8:
              conversation = _context27.sent;

              if (conversation) {
                _context27.next = 12;
                break;
              }

              // If there are no conversations yet, wait until the customer creates
              // a new message to create the new conversation
              this.setMessages(_toConsumableArray(this.getDefaultGreeting())).listenForNewConversations(_customerId6);
              return _context27.abrupt("return", null);

            case 12:
              conversationId = conversation.id, _conversation$message = conversation.messages, messages = _conversation$message === void 0 ? [] : _conversation$message;
              formattedMessages = messages.sort(function (a, b) {
                return +new Date(a.created_at) - +new Date(b.created_at);
              });
              _formattedMessages = _slicedToArray(formattedMessages, 1), initialMessage = _formattedMessages[0];
              initialMessageCreatedAt = initialMessage === null || initialMessage === void 0 ? void 0 : initialMessage.created_at;
              this.setConversationId(conversationId).setMessages([].concat(_toConsumableArray(this.getDefaultGreeting({
                created_at: initialMessageCreatedAt,
                seen_at: initialMessageCreatedAt
              })), _toConsumableArray(formattedMessages)));
              return _context27.abrupt("return", conversation);

            case 20:
              _context27.prev = 20;
              _context27.t0 = _context27["catch"](0);
              this.logger.debug('Error fetching conversations!', _context27.t0);

            case 23:
            case "end":
              return _context27.stop();
          }
        }
      }, _callee27, this, [[0, 20]]);
    }));
  };

  this.notify = function (type, message) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _this.logger.debug({
      type: type,
      message: message,
      options: options
    }); // TODO: make it super easy to send notifications from brower
    // consider rate limiting? blacklisting/whitelisting?
    // start new conversation vs send in existing?
    // tagging/labeling from function? (e.g. "feedback", "bug", etc?)
    // options can include... name, email, customer info, metadata?

  };

  var w = window;
  var baseUrl = config.baseUrl,
      accountId = config.accountId,
      customerId = config.customerId,
      inboxId = config.inboxId,
      _config$debug = config.debug,
      isDebugMode = _config$debug === void 0 ? false : _config$debug;
  var debugModeEnabled = isDev(w) || isDebugMode;
  this.config = config;
  this.logger = new Logger(debugModeEnabled);
  this.storage = store(w);
  this.customerId = customerId || this.getCachedCustomerId() || null;
  this.conversationId = null;
  this.messages = [];
  this.settings = {};
  var websocketUrl = getWebsocketUrl(baseUrl);
  this.socket = new phoenix.Socket(websocketUrl, {
    params: {
      account_id: accountId,
      inbox_id: inboxId
    }
  });
});

Papercups.init = function (config) {
  return new Papercups(config);
};

Papercups.open = function () {
  return window.dispatchEvent(new Event('papercups:open'));
};

Papercups.close = function () {
  return window.dispatchEvent(new Event('papercups:close'));
};

Papercups.toggle = function () {
  return window.dispatchEvent(new Event('papercups:toggle'));
};

var helpers = function helpers(win) {
  var ArrayProto = Array.prototype;
  var FuncProto = Function.prototype;
  var ObjProto = Object.prototype;
  var toString = ObjProto.toString;
  var hasOwnProperty = ObjProto.hasOwnProperty;
  var windowConsole = win.console;
  var navigator = win.navigator;
  var document = win.document;
  var windowOpera = win.opera;
  var screen = win.screen;
  var userAgent = navigator.userAgent;
  var intl = win.Intl;
  var nativeBind = FuncProto.bind;
  var nativeForEach = ArrayProto.forEach;
  var nativeIndexOf = ArrayProto.indexOf;
  var nativeIsArray = Array.isArray;
  var slice = ArrayProto.slice;
  var breaker = {};

  var __NOOP = function __NOOP() {};

  var __NOOPTIONS = {};

  var isArray = nativeIsArray || function (obj) {
    return toString.call(obj) === '[object Array]';
  };

  function isObject(obj) {
    return obj === Object(obj) && !isArray(obj);
  }

  function isFunction(f) {
    try {
      return /^\s*\bfunction\b/.test(f);
    } catch (x) {
      return false;
    }
  }

  function isString(obj) {
    return toString.call(obj) == '[object String]';
  }

  function includes(str, needle) {
    return str.indexOf(needle) !== -1;
  }

  function isUndefined(obj) {
    return obj === void 0;
  }

  function timestamp() {
    Date.now = Date.now || function () {
      return +new Date();
    };

    return Date.now();
  }

  function each(obj, iterator, context) {
    if (obj === null || obj === undefined) {
      return;
    }

    if (nativeForEach && obj.forEach === nativeForEach) {
      obj.forEach(iterator, context);
    } else if (obj.length === +obj.length) {
      for (var i = 0, l = obj.length; i < l; i++) {
        if (i in obj && iterator.call(context, obj[i], i, obj) === breaker) {
          return;
        }
      }
    } else {
      for (var key in obj) {
        if (hasOwnProperty.call(obj, key)) {
          if (iterator.call(context, obj[key], key, obj) === breaker) {
            return;
          }
        }
      }
    }
  }

  function trim(str) {
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
    return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
  }

  function extend(obj) {
    for (var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
      args[_key6 - 1] = arguments[_key6];
    }

    each(args, function (source) {
      for (var prop in source) {
        if (source[prop] !== void 0) {
          obj[prop] = source[prop];
        }
      }
    });
    return obj;
  }

  function bind(func, context) {
    var args;

    var _bound;

    if (nativeBind && func.bind === nativeBind) {
      args = slice.call(arguments, 1);
      return nativeBind.apply(func, args);
    }

    if (!isFunction(func)) {
      throw new TypeError();
    }

    args = slice.call(arguments, 2);

    _bound = function bound() {
      if (!(this instanceof _bound)) {
        return func.apply(context, args.concat(slice.call(arguments)));
      }

      var ctor = {};
      ctor.prototype = func.prototype;
      var self = new ctor();
      ctor.prototype = null;
      var result = func.apply(self, args.concat(slice.call(arguments)));

      if (Object(result) === result) {
        return result;
      }

      return self;
    };

    return _bound;
  }

  function truncate(obj, length) {
    var ret;

    if (typeof obj === 'string') {
      ret = obj.slice(0, length);
    } else if (isArray(obj)) {
      ret = [];
      each(obj, function (val) {
        ret.push(truncate(val, length));
      });
    } else if (isObject(obj)) {
      ret = {};
      each(obj, function (val, key) {
        ret[key] = truncate(val, length);
      });
    } else {
      ret = obj;
    }

    return ret;
  }

  function stripEmptyProperties(obj) {
    var ret = {};
    each(obj, function (v, k) {
      if (isString(v) && v.length > 0) {
        ret[k] = v;
      }
    });
    return ret;
  }

  function HTTPBuildQuery(formdata, arg_separator) {
    var use_val;
    var use_key;
    var arr = [];

    if (isUndefined(arg_separator)) {
      arg_separator = '&';
    }

    each(formdata, function (val, key) {
      use_val = encodeURIComponent(val.toString());
      use_key = encodeURIComponent(key);
      arr[arr.length] = use_key + '=' + use_val;
    });
    return arr.join(arg_separator);
  }

  var JSONEncode = function () {
    return function (mixed_val) {
      var value = mixed_val;

      var quote = function quote(string) {
        var escapable = /[\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g; // eslint-disable-line no-control-regex

        var meta = {
          // table of character substitutions
          '\b': '\\b',
          '\t': '\\t',
          '\n': '\\n',
          '\f': '\\f',
          '\r': '\\r',
          '"': '\\"',
          '\\': '\\\\'
        };
        escapable.lastIndex = 0;
        return escapable.test(string) ? '"' + string.replace(escapable, function (a) {
          var c = meta[a];
          return typeof c === 'string' ? c : "\\u" + ('0000' + a.charCodeAt(0).toString(16)).slice(-4);
        }) + '"' : '"' + string + '"';
      };

      var str = function str(key, holder) {
        var gap = '';
        var indent = '    ';
        var i = 0; // The loop counter.

        var k = ''; // The member key.

        var v = ''; // The member value.

        var length = 0;
        var mind = gap;
        var partial = [];
        var value = holder[key]; // If the value has a toJSON method, call it to obtain a replacement value.

        if (value && typeof value === 'object' && typeof value.toJSON === 'function') {
          value = value.toJSON(key);
        } // What happens next depends on the value's type.


        switch (typeof value) {
          case 'string':
            return quote(value);

          case 'number':
            // JSON numbers must be finite. Encode non-finite numbers as null.
            return isFinite(value) ? String(value) : 'null';

          case 'boolean':
          case 'undefined':
            // case 'null':
            // If the value is a boolean or null, convert it to a string. Note:
            // typeof null does not produce 'null'. The case is included here in
            // the remote chance that this gets fixed someday.
            return String(value);

          case 'object':
            // If the type is 'object', we might be dealing with an object or an array or
            // null.
            // Due to a specification blunder in ECMAScript, typeof null is 'object',
            // so watch out for that case.
            if (!value) {
              return 'null';
            } // Make an array to hold the partial results of stringifying this object value.


            gap += indent;
            partial = []; // Is the value an array?

            if (toString.apply(value) === '[object Array]') {
              // The value is an array. Stringify every element. Use null as a placeholder
              // for non-JSON values.
              length = value.length;

              for (i = 0; i < length; i += 1) {
                partial[i] = str(i, value) || 'null';
              } // Join all of the elements together, separated with commas, and wrap them in
              // brackets.


              v = partial.length === 0 ? '[]' : gap ? '[\n' + gap + partial.join(',\n' + gap) + '\n' + mind + ']' : '[' + partial.join(',') + ']';
              gap = mind;
              return v;
            } // Iterate through all of the keys in the object.


            for (k in value) {
              if (hasOwnProperty.call(value, k)) {
                v = str(k, value);

                if (v) {
                  partial.push(quote(k) + (gap ? ': ' : ':') + v);
                }
              }
            } // Join all of the member texts together, separated with commas,
            // and wrap them in braces.


            v = partial.length === 0 ? '{}' : gap ? '{' + partial.join(',') + '' + mind + '}' : '{' + partial.join(',') + '}';
            gap = mind;
            return v;
        }
      }; // Make a fake root object containing our value under the key of ''.
      // Return the result of stringifying the value.


      return str('', {
        '': value
      });
    };
  }();

  var JSONDecode = function () {
    var at; // The index of the current character

    var ch; // The current character

    var escapee = {
      '"': '"',
      '\\': '\\',
      '/': '/',
      b: '\b',
      f: '\f',
      n: '\n',
      r: '\r',
      t: '\t'
    };
    var text;

    var error = function error(m) {
      var e = new SyntaxError(m);
      e.at = at;
      e.text = text;
      throw e;
    };

    var next = function next(c) {
      // If a c parameter is provided, verify that it matches the current character.
      if (c && c !== ch) {
        error("Expected '" + c + "' instead of '" + ch + "'");
      } // Get the next character. When there are no more characters,
      // return the empty string.


      ch = text.charAt(at);
      at += 1;
      return ch;
    };

    var number = function number() {
      // Parse a number value.
      var number,
          string = '';

      if (ch === '-') {
        string = '-';
        next('-');
      }

      while (ch >= '0' && ch <= '9') {
        string += ch;
        next();
      }

      if (ch === '.') {
        string += '.';

        while (next() && ch >= '0' && ch <= '9') {
          string += ch;
        }
      }

      if (ch === 'e' || ch === 'E') {
        string += ch;
        next();

        if (ch === '-' || ch === '+') {
          string += ch;
          next();
        }

        while (ch >= '0' && ch <= '9') {
          string += ch;
          next();
        }
      }

      number = +string;

      if (!isFinite(number)) {
        error('Bad number');
      } else {
        return number;
      }
    };

    var string = function string() {
      // Parse a string value.
      var hex;
      var i;
      var string = '';
      var uffff; // When parsing for string values, we must look for " and \ characters.

      if (ch === '"') {
        while (next()) {
          if (ch === '"') {
            next();
            return string;
          }

          if (ch === '\\') {
            next();

            if (ch === 'u') {
              uffff = 0;

              for (i = 0; i < 4; i += 1) {
                hex = parseInt(next(), 16);

                if (!isFinite(hex)) {
                  break;
                }

                uffff = uffff * 16 + hex;
              }

              string += String.fromCharCode(uffff);
            } else if (typeof escapee[ch] === 'string') {
              string += escapee[ch];
            } else {
              break;
            }
          } else {
            string += ch;
          }
        }
      }

      error('Bad string');
    };

    var white = function white() {
      // Skip whitespace.
      while (ch && ch <= ' ') {
        next();
      }
    };

    var word = function word() {
      // true, false, or null.
      switch (ch) {
        case 't':
          next('t');
          next('r');
          next('u');
          next('e');
          return true;

        case 'f':
          next('f');
          next('a');
          next('l');
          next('s');
          next('e');
          return false;

        case 'n':
          next('n');
          next('u');
          next('l');
          next('l');
          return null;
      }

      error('Unexpected "' + ch + '"');
    };

    var value; // Placeholder for the value function.

    var array = function array() {
      // Parse an array value.
      var array = [];

      if (ch === '[') {
        next('[');
        white();

        if (ch === ']') {
          next(']');
          return array; // empty array
        }

        while (ch) {
          array.push(value());
          white();

          if (ch === ']') {
            next(']');
            return array;
          }

          next(',');
          white();
        }
      }

      error('Bad array');
    };

    var object = function object() {
      // Parse an object value.
      var key;
      var object = {};

      if (ch === '{') {
        next('{');
        white();

        if (ch === '}') {
          next('}');
          return object; // empty object
        }

        while (ch) {
          key = string();
          white();
          next(':');

          if (Object.hasOwnProperty.call(object, key)) {
            error('Duplicate key "' + key + '"');
          }

          object[key] = value();
          white();

          if (ch === '}') {
            next('}');
            return object;
          }

          next(',');
          white();
        }
      }

      error('Bad object');
    };

    value = function value() {
      // Parse a JSON value. It could be an object, an array, a string,
      // a number, or a word.
      white();

      switch (ch) {
        case '{':
          return object();

        case '[':
          return array();

        case '"':
          return string();

        case '-':
          return number();

        default:
          return ch >= '0' && ch <= '9' ? number() : word();
      }
    }; // Return the json_parse function. It will have access to all of the
    // above functions and variables.


    return function (source) {
      var result;
      text = source;
      at = 0;
      ch = ' ';
      result = value();
      white();

      if (ch) {
        error('Syntax error');
      }

      return result;
    };
  }();

  function utf8Encode(string) {
    string = (string + '').replace(/\r\n/g, '\n').replace(/\r/g, '\n');
    var utftext = '',
        start,
        end;
    var stringl = 0,
        n;
    start = end = 0;
    stringl = string.length;

    for (n = 0; n < stringl; n++) {
      var c1 = string.charCodeAt(n);
      var enc = null;

      if (c1 < 128) {
        end++;
      } else if (c1 > 127 && c1 < 2048) {
        enc = String.fromCharCode(c1 >> 6 | 192, c1 & 63 | 128);
      } else {
        enc = String.fromCharCode(c1 >> 12 | 224, c1 >> 6 & 63 | 128, c1 & 63 | 128);
      }

      if (enc !== null) {
        if (end > start) {
          utftext += string.substring(start, end);
        }

        utftext += enc;
        start = end = n + 1;
      }
    }

    if (end > start) {
      utftext += string.substring(start, string.length);
    }

    return utftext;
  }

  function base64Encode(data) {
    var b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    var o1;
    var o2;
    var o3;
    var h1;
    var h2;
    var h3;
    var h4;
    var bits;
    var i = 0;
    var ac = 0;
    var enc = '';
    var tmp_arr = [];

    if (!data) {
      return data;
    }

    data = utf8Encode(data);

    do {
      // pack three octets into four hexets
      o1 = data.charCodeAt(i++);
      o2 = data.charCodeAt(i++);
      o3 = data.charCodeAt(i++);
      bits = o1 << 16 | o2 << 8 | o3;
      h1 = bits >> 18 & 0x3f;
      h2 = bits >> 12 & 0x3f;
      h3 = bits >> 6 & 0x3f;
      h4 = bits & 0x3f; // use hexets to index into b64, and append result to encoded string

      tmp_arr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
    } while (i < data.length);

    enc = tmp_arr.join('');

    switch (data.length % 3) {
      case 1:
        enc = enc.slice(0, -2) + '==';
        break;

      case 2:
        enc = enc.slice(0, -1) + '=';
        break;
    }

    return enc;
  }

  function getQueryParam(url, param) {
    // Expects a raw URL
    param = param.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
    var regexS = '[\\?&]' + param + '=([^&#]*)';
    var regex = new RegExp(regexS);
    var results = regex.exec(url);

    if (results === null || results && typeof results[1] !== 'string' && results[1].length) {
      return '';
    } else {
      var result = results[1];

      try {
        result = decodeURIComponent(result);
      } catch (err) {
        console.error('Skipping decoding for malformed query param: ' + result);
      }

      return result.replace(/\+/g, ' ');
    }
  }

  return {
    ArrayProto: ArrayProto,
    FuncProto: FuncProto,
    ObjProto: ObjProto,
    toString: toString,
    hasOwnProperty: hasOwnProperty,
    win: win,
    windowConsole: windowConsole,
    navigator: navigator,
    document: document,
    windowOpera: windowOpera,
    screen: screen,
    userAgent: userAgent,
    intl: intl,
    nativeBind: nativeBind,
    nativeForEach: nativeForEach,
    nativeIndexOf: nativeIndexOf,
    nativeIsArray: nativeIsArray,
    slice: slice,
    breaker: breaker,
    __NOOP: __NOOP,
    __NOOPTIONS: __NOOPTIONS,
    isFunction: isFunction,
    isString: isString,
    includes: includes,
    isUndefined: isUndefined,
    timestamp: timestamp,
    each: each,
    trim: trim,
    extend: extend,
    bind: bind,
    truncate: truncate,
    stripEmptyProperties: stripEmptyProperties,
    HTTPBuildQuery: HTTPBuildQuery,
    JSONEncode: JSONEncode,
    JSONDecode: JSONDecode,
    utf8Encode: utf8Encode,
    base64Encode: base64Encode,
    getQueryParam: getQueryParam
  };
};

function getUserInfo(win) {
  var _helpers = helpers(win),
      navigator = _helpers.navigator,
      userAgent = _helpers.userAgent,
      windowOpera = _helpers.windowOpera,
      intl = _helpers.intl,
      each = _helpers.each,
      extend = _helpers.extend,
      includes = _helpers.includes,
      timestamp = _helpers.timestamp,
      stripEmptyProperties = _helpers.stripEmptyProperties,
      getQueryParam = _helpers.getQueryParam; // Mostly borrowed from:
  // https://github.com/PostHog/posthog-js/blob/dbfac85a2808626e3c1780013a9075d5c9fd0971/src/utils.js#L1433


  var info = {
    campaignParams: function campaignParams() {
      var campaign_keywords = 'utm_source utm_medium utm_campaign utm_content utm_term'.split(' ');
      var kw = '';
      var params = {};
      each(campaign_keywords, function (kwkey) {
        kw = getQueryParam(document.URL, kwkey);

        if (kw.length) {
          params[kwkey] = kw;
        }
      });
      return params;
    },
    searchEngine: function searchEngine(referrer) {
      if (referrer.search('https?://(.*)google.([^/?]*)') === 0) {
        return 'google';
      } else if (referrer.search('https?://(.*)bing.com') === 0) {
        return 'bing';
      } else if (referrer.search('https?://(.*)yahoo.com') === 0) {
        return 'yahoo';
      } else if (referrer.search('https?://(.*)duckduckgo.com') === 0) {
        return 'duckduckgo';
      } else {
        return null;
      }
    },
    searchInfo: function searchInfo(referrer) {
      var search = info.searchEngine(referrer);
      var param = search != 'yahoo' ? 'q' : 'p';
      var ret = {};

      if (search !== null) {
        ret['$search_engine'] = search;
        var keyword = getQueryParam(referrer, param);

        if (keyword.length) {
          ret['ph_keyword'] = keyword;
        }
      }

      return ret;
    },

    /**
     * This function detects which browser is running this script.
     * The order of the checks are important since many user agents
     * include key words used in later checks.
     */
    browser: function browser(user_agent, vendor, opera) {
      vendor = vendor || ''; // vendor is undefined for at least IE9

      if (opera || includes(user_agent, ' OPR/')) {
        if (includes(user_agent, 'Mini')) {
          return 'Opera Mini';
        }

        return 'Opera';
      } else if (/(BlackBerry|PlayBook|BB10)/i.test(user_agent)) {
        return 'BlackBerry';
      } else if (includes(user_agent, 'IEMobile') || includes(user_agent, 'WPDesktop')) {
        return 'Internet Explorer Mobile';
      } else if (includes(user_agent, 'SamsungBrowser/')) {
        // https://developer.samsung.com/internet/user-agent-string-format
        return 'Samsung Internet';
      } else if (includes(user_agent, 'Edge') || includes(user_agent, 'Edg/')) {
        return 'Microsoft Edge';
      } else if (includes(user_agent, 'FBIOS')) {
        return 'Facebook Mobile';
      } else if (includes(user_agent, 'Chrome')) {
        return 'Chrome';
      } else if (includes(user_agent, 'CriOS')) {
        return 'Chrome iOS';
      } else if (includes(user_agent, 'UCWEB') || includes(user_agent, 'UCBrowser')) {
        return 'UC Browser';
      } else if (includes(user_agent, 'FxiOS')) {
        return 'Firefox iOS';
      } else if (includes(vendor, 'Apple')) {
        if (includes(user_agent, 'Mobile')) {
          return 'Mobile Safari';
        }

        return 'Safari';
      } else if (includes(user_agent, 'Android')) {
        return 'Android Mobile';
      } else if (includes(user_agent, 'Konqueror')) {
        return 'Konqueror';
      } else if (includes(user_agent, 'Firefox')) {
        return 'Firefox';
      } else if (includes(user_agent, 'MSIE') || includes(user_agent, 'Trident/')) {
        return 'Internet Explorer';
      } else if (includes(user_agent, 'Gecko')) {
        return 'Mozilla';
      } else {
        return '';
      }
    },

    /**
     * This function detects which browser version is running this script,
     * parsing major and minor version (e.g., 42.1). User agent strings from:
     * http://www.useragentstring.com/pages/useragentstring.php
     */
    browserVersion: function browserVersion(userAgent, vendor, opera) {
      var browser = info.browser(userAgent, vendor, opera);
      var versionRegexs = {
        'Internet Explorer Mobile': /rv:(\d+(\.\d+)?)/,
        'Microsoft Edge': /Edge?\/(\d+(\.\d+)?)/,
        Chrome: /Chrome\/(\d+(\.\d+)?)/,
        'Chrome iOS': /CriOS\/(\d+(\.\d+)?)/,
        'UC Browser': /(UCBrowser|UCWEB)\/(\d+(\.\d+)?)/,
        Safari: /Version\/(\d+(\.\d+)?)/,
        'Mobile Safari': /Version\/(\d+(\.\d+)?)/,
        Opera: /(Opera|OPR)\/(\d+(\.\d+)?)/,
        Firefox: /Firefox\/(\d+(\.\d+)?)/,
        'Firefox iOS': /FxiOS\/(\d+(\.\d+)?)/,
        Konqueror: /Konqueror:(\d+(\.\d+)?)/,
        BlackBerry: /BlackBerry (\d+(\.\d+)?)/,
        'Android Mobile': /android\s(\d+(\.\d+)?)/,
        'Samsung Internet': /SamsungBrowser\/(\d+(\.\d+)?)/,
        'Internet Explorer': /(rv:|MSIE )(\d+(\.\d+)?)/,
        Mozilla: /rv:(\d+(\.\d+)?)/
      };
      var regex = versionRegexs[browser];

      if (regex === undefined) {
        return null;
      }

      var matches = userAgent.match(regex);

      if (!matches) {
        return null;
      }

      return parseFloat(matches[matches.length - 2]);
    },
    os: function os() {
      var a = userAgent;

      if (/Windows/i.test(a)) {
        if (/Phone/.test(a) || /WPDesktop/.test(a)) {
          return 'Windows Phone';
        }

        return 'Windows';
      } else if (/(iPhone|iPad|iPod)/.test(a)) {
        return 'iOS';
      } else if (/Android/.test(a)) {
        return 'Android';
      } else if (/(BlackBerry|PlayBook|BB10)/i.test(a)) {
        return 'BlackBerry';
      } else if (/Mac/i.test(a)) {
        return 'Mac OS X';
      } else if (/Linux/.test(a)) {
        return 'Linux';
      } else if (/CrOS/.test(a)) {
        return 'Chrome OS';
      } else {
        return '';
      }
    },
    device: function device(user_agent) {
      if (/Windows Phone/i.test(user_agent) || /WPDesktop/.test(user_agent)) {
        return 'Windows Phone';
      } else if (/iPad/.test(user_agent)) {
        return 'iPad';
      } else if (/iPod/.test(user_agent)) {
        return 'iPod Touch';
      } else if (/iPhone/.test(user_agent)) {
        return 'iPhone';
      } else if (/(BlackBerry|PlayBook|BB10)/i.test(user_agent)) {
        return 'BlackBerry';
      } else if (/Android/.test(user_agent)) {
        return 'Android';
      } else {
        return '';
      }
    },
    referringDomain: function referringDomain(referrer) {
      var split = referrer.split('/');

      if (split.length >= 3) {
        return split[2];
      }

      return '';
    },
    timezone: function timezone(intl) {
      try {
        return intl.DateTimeFormat().resolvedOptions().timeZone;
      } catch (e) {
        return null;
      }
    },
    properties: function properties() {
      var _a;

      return extend(stripEmptyProperties({
        os: info.os(),
        browser: info.browser(userAgent, navigator.vendor, windowOpera),
        referrer: document.referrer,
        referring_domain: info.referringDomain(document.referrer),
        device: info.device(userAgent),
        time_zone: info.timezone(intl)
      }), {
        current_url: win.location.href,
        host: win.location.host,
        pathname: win.location.pathname,
        browser_version: (_a = info.browserVersion(userAgent, navigator.vendor, windowOpera)) === null || _a === void 0 ? void 0 : _a.toString(),
        screen_height: screen.height,
        screen_width: screen.width,
        lib: 'web',
        insert_id: Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10),
        time: timestamp() / 1000
      });
    }
  };
  return info.properties();
}

export { Papercups, createNewConversation, createNewCustomer, fetchCustomerConversations, fetchWidgetSettings, findCustomerByExternalId, getUserInfo, isAgentMessage, isCustomerMessage, isValidCustomer, isValidUuid, setupCustomEventHandlers, setupPostMessageHandlers, shouldActivateGameMode, updateCustomerMetadata, updateWidgetSettingsMetadata, upload };